









import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import CoverFallback from '@/assets/vynil.svg';
import StationFallback from '@/assets/station.svg';

@Component
export default class MelosCover extends Vue {
  @Prop() private showSpecificCover!: boolean;
  @Prop() private coverSrc!: string;
  @Prop() private isStation!: boolean;
  private coverSize: number = 0;
  private forceFallback: boolean = false;

  private mounted() {
    if (!this.showSpecificCover) {
      this.updateCoverSize();
      const windowObj: any = window as any;
      windowObj.addEventListener('resize', this.updateCoverSize);
    }
  }

  @Watch('carouselHeight')
  private onCarouselHeightChanged() {
    this.updateCoverSize();
  }

  private updateCoverSize() {
    const coverContainer = this.$refs.coverContainer as any;
    this.coverSize = 0.8 * Math.min(coverContainer.clientWidth, coverContainer.clientHeight);
    if (this.coverSize === 0) {
      setTimeout(() => this.updateCoverSize());
    }
  }

  private get currentContent() {
    return this.$store.state.player?.trackTitle;
  }

  private get playerCover() {
    return this.$store.state.player?.imageSrc;
  }

  @Watch('playerCover')
  private onPlayerCoverChanged() {
    this.forceFallback = false;
  }

  @Watch('coverSrc')
  private onCoverSrcChanged() {
    this.forceFallback = false;
  }

  private get imageSrc(): string {
    if (this.forceFallback) {
      return this.fallbackImage;
    }
    if (this.showSpecificCover) {
      return this.coverSrc || this.fallbackImage;
    }
    return this.playerCover || this.fallbackImage;
  }

  private get fallbackImage() {
    return this.isStation ? StationFallback : CoverFallback;
  }

  private get carouselHeight(): number {
    return this.$store.state.interfaceData.carouselHeight;
  }
}
